import { createUseStyles } from 'react-jss';

export const useHeaderStyle = createUseStyles({
    logoLink: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',

        '&:after': {
            content: "''",
            width: '1px',
            height: '100%',
            backgroundColor: `var(--border-opaque)`,
            position: 'absolute',
            bottom: 0,
            right: 0,
        },
    },
});
